/* global window */

import * as types from '../../../../store/mutation-types';
import PicForm from '../pic-form/pic-form';

export default {
  props: ['plotCartSize', 'activeProject'],
  components: {
    'pic-form': PicForm,
  },
  data() {
    return {};
  },
  computed: {
    purchase() {
      return this.$store.state.map.purchase;
    },
    isPaid() {
      return this.$store.state.map.purchase.status === 'paid';
    },
    price() {
      return Number(this.activeProject.picValue[0]);
    },
    currency() {
      return this.activeProject.picValue[1];
    },
  },
  methods: {
    closePurchaseSidebar() {
      this.$store.commit(types.TOGGLE_PURCHASE_SIDEBAR, false);
      if (this.purchase.email) {
        this.resetPurchase();
      }
    },
    openPurchaseSidebar() {
      this.$store.commit(types.TOGGLE_PURCHASE_SIDEBAR, true);
    },
    resetPurchase() {
      this.$store.commit(types.RESET_PURCHASE);
      this.$store.commit(types.CLEAR_CART);
    },
    share() {
      const url = encodeURIComponent(`${window.location.href}&s=${this.purchase.shareHash}`);
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank', 'height=600,width=400');
    },
  },
};
